import React from 'react';
import { Link } from 'react-router-dom';
import UpvoteButton from './UpvoteButton';
import { FeaturePills } from './FeaturePills';
import { formatNameWithInitials, formatMusicStyles } from '../helpers/constants';

export default function BarCard({ bar, userId, onToggleUpvote, onRequireLogin }) {
  const musicStylesText = formatMusicStyles(bar.musicStyles);

  return (
    <div className="bar-card">
      <div className="bar-card-header">
        <div className="bar-card-title">
          <Link to={`/bar/${bar.key}`} className="bar-name-link">
            <h3>
              {bar.name}
              {musicStylesText && <span className="music-style-badge">{musicStylesText}</span>}
            </h3>
          </Link>
          {bar.neighborhood && <span className="bar-neighborhood">{bar.neighborhood}</span>}
        </div>
      </div>

      {bar.notes && <p className="bar-notes">{bar.notes}</p>}

      <FeaturePills bar={bar} />

      <div className="bar-card-footer">
        <UpvoteButton
          bar={bar}
          userId={userId}
          onToggle={() => onToggleUpvote(bar)}
          onRequireLogin={onRequireLogin}
        />
        <div className="bar-card-actions">
          <Link to={`/bar/${bar.key}`} className="bar-comment-button">
            <span className="comment-icon">💬</span>
            {bar.commentCount > 0 && <span className="comment-count">{bar.commentCount}</span>}
          </Link>
        </div>
        {bar.createdByName && (
          <span className="bar-author">Sugerido por {formatNameWithInitials(bar.createdByName)}</span>
        )}
      </div>
    </div>
  );
}
